export enum PermissionPaymentsOption {
  PAYMENTS_COMMON_LOGIN = 'metodos-de-pago',
  PAYMENTS_METHOD_RECHARGE_LIST = '/metodos-de-pago/metodo-pago',
  PAYMENTS_METHOD_RECHARGE_ACCOUNT = '/metodos-de-pago/recargar-cuenta',
  PAYMENTS_METHOD_SHOW_SUMMARY = '/metodos-de-pago/resumen-de-transaccion',
  PAYMENTS_METHOD_SHOW_BALANCE = 'payments.method.showBalance',
  PAYMENTS_METHOD_SHOW_ITEM_MPAY = 'domi.method.showItemMpay',

  /** FLAGS */
  PAYMENTS_FLAG_LIST_ADD_CREDIT_CARD_CO = 'payments_flag_list_add_credit_card_co',
  PAYMENTS_FLAG_LIST_ADD_CREDIT_CARD_MX = 'payments_flag_list_add_credit_card_mx',
  PAYMENTS_FLAG_PSE_CO = 'payments_flag_pse_co',
  PAYMENTS_FLAG_TRANSFER_MX = 'payments_flag_transfer_mx',
}
